import useIsNLplan from '../../../common/src/hooks/useIsNLPlan';
import {
  useFlowsDispatch,
  useFlowsSelector,
} from '../../../common/src/utils/globalVariables';
import useCompanyScanFlowId from '../../../company-scan/hooks/useCompanyScanFlowId';
import {
  getAskLaterQuestions,
  useAskLaterQuestions,
} from '../components/ui/company-scan/components/ask-later-questions/api/getAskLaterQuestion';
import { flowIdCompanyScanBE, flowIdCompanyScanNL } from '../constants/flowIds';
import {
  checkQuestionnaire,
  setAskLaterQuestions,
  setIsLoading,
  setPreviewMode,
} from '../store/redux/slices/flowsSlice';
import useFlowsMove from './useFlowsMove';

interface UsePreviewMode {
  on: () => Promise<void>;
  off: () => void;
  toggle: () => Promise<void>;
  isPreviewModeOn: boolean;
  isDisabled: boolean;
}

const usePreviewMode = (partyId?: string): UsePreviewMode => {
  const { isNL } = useIsNLplan();
  const isPreviewModeOn = useFlowsSelector(
    (state) => state.flows.isPreviewModeOn,
  );
  const flowId = useCompanyScanFlowId();
  const flowsDispatch = useFlowsDispatch();
  const { moveToPosition } = useFlowsMove();

  const { data } = useAskLaterQuestions({ flowId });

  const on = async () => {
    flowsDispatch(setIsLoading(true));

    let questions;
    if (data) {
      questions = data;
    } else if (partyId) {
      const [resp, status] = await getAskLaterQuestions({
        flow_id: isNL ? flowIdCompanyScanNL : flowIdCompanyScanBE,
        party_id: partyId,
      });
      if (status >= 400) flowsDispatch(setIsLoading(true));
      questions = resp;
    }

    if (questions) {
      flowsDispatch(setAskLaterQuestions(questions));
      flowsDispatch(setPreviewMode(true));
      flowsDispatch(checkQuestionnaire());
      moveToPosition(0);
      flowsDispatch(setIsLoading(false));
    }
  };

  const off = () => {
    flowsDispatch(setIsLoading(true));
    flowsDispatch(setPreviewMode(false));
    flowsDispatch(setAskLaterQuestions({ questions: [] }));
    flowsDispatch(checkQuestionnaire());
    moveToPosition(0);
    flowsDispatch(setIsLoading(false));
  };

  const toggle = async () => {
    if (isPreviewModeOn) off();
    else await on();
  };

  return {
    on,
    off,
    toggle,
    isPreviewModeOn,
    isDisabled: data?.questions ? data?.questions.length === 0 : true,
  };
};

export default usePreviewMode;
